import { useDisclosure } from "@chakra-ui/react";
import { useState } from "react";

type MediaType = "video" | "image";
const useMediaModal = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  // const [mediaType, setMediaType] = useState(null);
  // const [mediaUrl, setMediaUrl] = useState(null);

  const [mediaType, setMediaType] = useState<MediaType | null>(null);
  const [mediaUrl, setMediaUrl] = useState<string | null>(null);

  const handleOpenModal = (type: MediaType, url: string | null) => {
    if (!type || !url) return;
    setMediaType(type);
    setMediaUrl(url);
    onOpen();
  };

  const handleCloseModal = () => {
    setMediaType(null);
    setMediaUrl(null);
    onClose();
  };

  return {
    isOpen,
    handleOpenModal,
    handleCloseModal,
    mediaType,
    mediaUrl,
  };
};

export default useMediaModal;
